
// Check online status
export const checkOnlineStatus = (): boolean => {
  return navigator.onLine;
};

// Format error messages
export const formatErrorMessage = (error: any): string => {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
};

// Get Baileys server URL
export const getBaileysServerURL = (): string => {
  return "https://api.wassi.chat"; // Direct wassi.chat API URL
};

// Get Wassi API Key
export const getWassiApiKey = (): string => {
  return "23257599add7ae89a708a6ccd4a90cb720eee80098e96a1ef4b73293bdbe7d5c55a76402569376b1";
};

// Check if Baileys server is active
export const checkBaileysServerActive = async (): Promise<boolean> => {
  try {
    const response = await fetch(`${getBaileysServerURL()}/api/health`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getWassiApiKey()}`
      }
    });
    return response.ok;
  } catch (error) {
    console.error('Error checking Baileys server status:', error);
    return false;
  }
};

// Check WhatsApp connection status
export const checkWhatsAppConnection = async (): Promise<{ connected: boolean, edgeFunctionError?: boolean, baileysError?: string }> => {
  try {
    const serverActive = await checkBaileysServerActive();
    return { connected: serverActive };
  } catch (error) {
    console.error('Error checking WhatsApp connection:', error);
    return { connected: false, baileysError: formatErrorMessage(error) };
  }
};

// Parse Baileys error
export const parseBaileysError = (error: any): string => {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unknown error occurred';
};

// Format phone number for WhatsApp API
export const formatPhoneNumber = (number: string): string => {
  // Format for WhatsApp API: should be in the format "country code + number" without any symbols
  // Example: 491234567890 for a German number
  let formatted = number.replace(/\s+/g, "");
  
  // If the number doesn't start with a + and doesn't have a country code, add German code
  if (!formatted.startsWith("+") && !formatted.startsWith("49")) {
    // If it starts with a 0, replace it with the country code
    if (formatted.startsWith("0")) {
      formatted = "49" + formatted.substring(1);
    } else {
      formatted = "49" + formatted;
    }
  } else if (formatted.startsWith("+")) {
    // Remove the + symbol
    formatted = formatted.substring(1);
  }
  
  return formatted;
};

// Validate phone number (basic validation)
export const validatePhoneNumber = (number: string): boolean => {
  // Basic validation - can be enhanced
  return number.replace(/\s+/g, "").match(/^\+?[0-9]{10,15}$/) !== null;
};
